import { type ButtonVariant, Button as MantineButton } from "@mantine/core"

import classNames from "./button.module.css"

export const Button = MantineButton.extend({ classNames })

type ExtendedButtonVariant = ButtonVariant | "save" | "navy" | "info" | "undo"

declare module "@mantine/core" {
  export interface ButtonProps {
    variant?: ExtendedButtonVariant
  }
}
